module.exports = __webpack_public_path__ + "img/02_BC2_gossip.a76b317a.jpg";